<template>
	<SelectedItems
		v-if="hasSelectedChildsToLastLevel"
		:characteristic-items="characteristic.children"
		:selected="selected"
		:no-children-appendix="noChildrenAppendix"
		:styling="styling"
		:label-type="labelType"
		:clickable="true"
		:show-experience="showExperience"
		@editItem="$emit('editItem', $event)"
	/>
</template>

<script>
import Label from "@/vue/characteristic/Label";
import {hasSelectedChildsToLastLevel} from "@/helper/characteristic/Characteristic";
import SelectedItems from "@/vue/characteristic/SelectedItems";

export default {

	components: {
		SelectedItems,
		Label,
	},

	props: {
		characteristic: {
			type: Object,
			required: true,
		},
		selected: {
			type: Array,
			required: false,
			default: () => []
		},
		noChildrenAppendix: {
			type: String,
			required: false,
		},
		styling: {
			type: String,
			required: false
		},
		labelType: {
			type: String,
			required: false
		},
		showExperience: {
			type: Boolean,
			required: false,
		}
	},

	methods: {
		hasSelectedChildsToLastLevel ()
		{
			return hasSelectedChildsToLastLevel(this.selected, this.characteristic);
		},
	}
}
</script>
